import { useMemo, useState } from 'react'
import { ISingleConversation } from '../../providers/chat-provider'
import UseChat from '../../utils/useChat'
import clsx from 'clsx'
import GetRandomMemoji from '../../utils/getRandomMemoji'
import moment from 'moment'

interface IConversationSingle {
    item: ISingleConversation
}

const ConvserationSingle: React.FC<IConversationSingle> = ({ item }) => {
    const { currentConversation, setCurrentConversation } = UseChat()
    const [unreadCount, setUnreadCount] = useState<number>(item.unReadMessageCount)
    const isUnReplied = !unreadCount && item.repliedBy === "p" ? true : false
    const [memoji, setMemoji] = useState<any | null>(null)
    const isActive = currentConversation?.id === item?.id
    const lastMessage = item.messages?.[0]

    // ------------------------------- [ SET MEMOJI ] -----------------------------------

    useMemo(() => {
        if (!memoji) {
            const newMemoji = JSON.parse(localStorage.getItem(`con_${item?.id}`)) || GetRandomMemoji()
            setMemoji(newMemoji)
            localStorage.setItem(`con_${item?.id}`, JSON.stringify(newMemoji))
        }
    }, [memoji, item?.id])

    return (
        <div
            className={clsx(
                'w-full py-3 px-5 cursor-pointer border-b border-edge-faint border-l-[3px] transition-colors duration-200',
                isActive
                    ? 'bg-active-background border-l-blue'
                    : 'border-l-transparent hover:bg-overlay-hover'
            )}
            onClick={() => {
                setCurrentConversation(item)
                setUnreadCount(0)
            }}
        >
            <div className='w-full flex items-center gap-3'>
                <div className='h-10 w-10 shrink-0 rounded-full border border-edge bg-overlay-mid flex items-center justify-center overflow-hidden'>
                    <img src={memoji} alt='Avatar' className='w-[80%]' />
                </div>

                <div className='flex-1 min-w-0'>
                    <div className='flex items-center gap-2'>
                        <h2 className='flex-1 min-w-0 text-[14px] font-semibold text-text-primary truncate capitalize'>
                            {item.firstName + " " + item.surname}
                        </h2>

                        {item?.lastUpdated ? (
                            <span className='shrink-0 text-[11px] font-medium text-light-gray tabular-nums'>
                                {moment(item.lastUpdated).format("DD MMM")}
                            </span>
                        ) : null}
                    </div>

                    <div className='flex items-center gap-2 mt-0.5'>
                        <p className='flex-1 min-w-0 text-[12px] font-medium text-light-gray truncate'>
                            {lastMessage?.message || "No messages yet"}
                        </p>

                        {unreadCount ? (
                            <span className='shrink-0 min-w-[18px] h-[18px] px-1.5 flex items-center justify-center text-[10px] font-bold tabular-nums rounded-full bg-gradient-to-r from-accent to-accent-bright text-white shadow-glow-sm'>
                                {unreadCount}
                            </span>
                        ) : isUnReplied ? (
                            <span
                                title='Awaiting your reply'
                                className='shrink-0 h-2 w-2 rounded-full bg-emerald-500'
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConvserationSingle
